/**
 * Styled Components - Created by david on 08/06/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  height: 100%;
  overflow-y: scroll;
`

export const VideoContainer = styled.div`
  display: flex;
  flex-flow: column;
  margin: 16px;
`
export const Loading = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  text-align: center;
  width: 100%;
`
export const VideoFrame = styled.iframe`
  width: 100%;
  margin-bottom: 4px;
`

export const Title = styled.span`
  margin-left: 4px;
  margin-bottom: 8px;
`
export const ModalSpan = styled.span`
  border: 1px solid red;
  padding: 2px 8px;
  border-radius: 3px;
  cursor: pointer;
  color: red;
  width: 106px;
  margin: 0 auto;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/TutorialsTab/styledComponents.tsx